import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import styles from './loader.css';
import PropTypes from 'prop-types';
const messages = [
    {
        message: (
            <FormattedMessage
                defaultMessage="Creating blocks …"
                description="One of the loading messages"
                id="gui.loader.message1"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Loading sprites …"
                description="One of the loading messages"
                id="gui.loader.message2"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Loading sounds …"
                description="One of the loading messages"
                id="gui.loader.message3"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Loading extensions …"
                description="One of the loading messages"
                id="gui.loader.message4"
            />
        ),
        weight: 50
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Creating blocks …"
                description="One of the loading messages"
                id="gui.loader.message1"
            />
        ),
        weight: 20
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Herding cats …"
                description="One of the loading messages"
                id="gui.loader.message5"
            />
        ),
        weight: 1
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Transmitting nanos …"
                description="One of the loading messages"
                id="gui.loader.message6"
            />
        ),
        weight: 1
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Inflating gobos …"
                description="One of the loading messages"
                id="gui.loader.message7"
            />
        ),
        weight: 1
    },
    {
        message: (
            <FormattedMessage
                defaultMessage="Preparing emojis …"
                description="One of the loading messages"
                id="gui.loader.message8"
            />
        ),
        weight: 1
    }
];
const mainMessages = {
    'gui.loader.headline': (
        <FormattedMessage
            defaultMessage="Loading Project"
            description="Main loading message"
            id="gui.loader.headline"
        />
    ),
    'gui.loader.creating': (
        <FormattedMessage
            defaultMessage="Creating Project"
            description="Main creating message"
            id="gui.loader.creating"
        />
    )
};

class LoaderComponent extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            messageNumber: this.chooseRandomMessage()
        };
    }
    componentDidMount () {
        // Start an interval to choose a new message every 5 seconds
        this.intervalId = setInterval(() => {
            this.setState({messageNumber: this.chooseRandomMessage()});
        }, 5000);
    }
    componentWillUnmount () {
        clearInterval(this.intervalId);
    }
    chooseRandomMessage () {
        let messageNumber;
        const sum = messages.reduce((acc, m) => acc + m.weight, 0);
        let rand = sum * Math.random();
        for (let i = 0; i < messages.length; i++) {
            rand -= messages[i].weight;
            if (rand <= 0) {
                messageNumber = i;
                break;
            }
        }
        return messageNumber;
    }
    render () {
        return (
            <div
                className={classNames(styles.background, {
                    [styles.fullscreen]: this.props.isFullScreen
                })}
            >
                <div className={styles.container}>
                    <svg
                        className={styles.spinner}
                        viewBox="0 0 200 200"
                    >
                        {/* r=85  C≈534  270°arc≈401  gap≈133 */}
                        <circle className={`${styles.ring} ${styles['ring-1']}`} cx="100" cy="100" r="85"
                            strokeDasharray="401 133" strokeDashoffset="0"
                        />
                        {/* r=72  C≈452  270°arc≈339  gap≈113 */}
                        <circle className={`${styles.ring} ${styles['ring-2']}`} cx="100" cy="100" r="72"
                            strokeDasharray="339 113" strokeDashoffset="-30"
                        />
                        {/* r=59  C≈371  270°arc≈278  gap≈93 */}
                        <circle className={`${styles.ring} ${styles['ring-3']}`} cx="100" cy="100" r="59"
                            strokeDasharray="278 93" strokeDashoffset="-60"
                        />
                        {/* r=46  C≈289  270°arc≈217  gap≈72 */}
                        <circle className={`${styles.ring} ${styles['ring-4']}`} cx="100" cy="100" r="46"
                            strokeDasharray="217 72" strokeDashoffset="-90"
                        />
                        {/* r=33  C≈207  270°arc≈155  gap≈52 */}
                        <circle className={`${styles.ring} ${styles['ring-5']}`} cx="100" cy="100" r="33"
                            strokeDasharray="155 52" strokeDashoffset="-120"
                        />
                        {/* r=21  C≈132  270°arc≈99  gap≈33 */}
                        <circle className={`${styles.ring} ${styles['ring-6']}`} cx="100" cy="100" r="21"
                            strokeDasharray="99 33" strokeDashoffset="-150"
                        />
                        {/* r=10  C≈63  270°arc≈47  gap≈16 */}
                        <circle className={`${styles.ring} ${styles['ring-7']}`} cx="100" cy="100" r="10"
                            strokeDasharray="47 16" strokeDashoffset="-180"
                        />
                    </svg>
                    <div className={styles.title}>
                        {mainMessages[this.props.messageId]}
                    </div>
                    <div className={styles.messageContainerOuter}>
                        <div
                            className={styles.messageContainerInner}
                            style={{transform: `translate(0, -${this.state.messageNumber * 25}px)`}}
                        >
                            {messages.map((m, i) => (
                                <div
                                    className={styles.message}
                                    key={i}
                                >
                                    {m.message}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LoaderComponent.propTypes = {
    isFullScreen: PropTypes.bool,
    messageId: PropTypes.string
};
LoaderComponent.defaultProps = {
    isFullScreen: false,
    messageId: 'gui.loader.headline'
};

export default LoaderComponent;
